import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StateHelper {

  /**
   * Page title
   */
  readonly title = signal('');

  /**
   * Page id
   */
  readonly page = signal('');

  /**
   * Set the page title
   */
  setTitle(title: string) {
    return this.title.set(title);
  }

  /**
   * Set the page id
   */
  setPage(page: string) {
    return this.page.set(page);
  }
}
